<template>
  <div class="row justify-center postion-relative">
    <div v-for="(value, key) in values" :key="key"
      :class="{ 'col-40': values.length === 2, 'col-25': values.length === 4, 'col-30': values.length === 3 }"
      class="no-shrink selection-box-parent position-relative" ref="selection-box-parent">
      <div class="selection-box " @click="$emit('update:modelValue', value)">
        <div v-if="value.imgHeight && value.imgWidth" class="img-container">
          <img :src="value.img" :style="{ width: value.imgWidth, height: value.imgHeight }" />
        </div>
        <div v-else class="img-container">
          <img :src="value.img" />
        </div>
        <div>
          <div class="d-flex">
            <div>{{ value.label }}</div>
            <div v-if="infoIcon"><img src="/calculateur-carbone-eclore/images/info_icon.png" width="20" height="20"
                class="icon-information" /></div>
          </div>
          <div v-if="value.description && isTouch === false" >
            <div  class="description">{{ value.description }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {data() {
    return {
      isTouch: false,
    };
  },
  methods: {
    getValuesForThisRow(n) {
      let filterValue = []
      this.values.forEach((value, key) => {
        if (
          key < (this.values.length / this.numberRow) * n &&
          key >= (this.values.length / this.numberRow) * (n - 1)
        ) {
          filterValue.push(value)
        }
      });
      return filterValue
    },
    checkIfTouchDevice() {
      return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }
  },
  props: {
    values: Array,
    around: { type: Boolean, default: false },
    infoIcon: { type: Boolean, default: false },
  },
  mounted() {
    this.isTouch = this.checkIfTouchDevice();
  }
};
</script>
<style scoped>
.col-25 {
  width: 24%;
}
.selection-box {
  background-color: white;
  padding: 12px 33px 12px 33px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
  border-radius: 0px 0px 50px 0px;
  color: var(--text-color);
  text-align: center;
  font-family: var(--font);
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.1em;
  flex-grow: 0;
  flex-basis: 0;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  height: calc(100% - 35px);
}

.selection-box::-webkit-scrollbar {
  width: 10px;
}

/* Track */
.selection-box::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.selection-box::-webkit-scrollbar-thumb {
  background: #03B5C6;
}
.description {
  color: var(--text-color);
  /* DESKTOP/H6 */
  font-family: var(--font);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28.2px;
  /* 141% */
  display: none;
  text-align: left;
}

.img-container>img {
  width: 172px;
}

.icon-information {
  display: none;
}

@media (max-width: 1486px) {
  .img-container>img {
    margin-right: 15px;
    max-width: 120px !important;
    height: auto !important;
  }

  .selection-box {
    font-size: 20px;
  }
}

@media (max-width: 1300px) {
  .col-25 {
    width: 50%;
  }

  .col-30 {}

  .col-40 {
    width: 50%;
  }
}

@media (max-width: 600px) {
  .col-25 {
    width: 100%;
  }

  .col-30 {
    width: 100%;
  }

  .col-40 {
    width: 100%;
  }

  .selection-box {
    flex-direction: row;
    margin-top: 25px;
    font-size: 18px;
  }

  .img-container>img {
    margin-right: 15px;
    max-width: 100px !important;
    height: auto !important;
  }

  .description {
    font-size: 14px;
    line-height: 16px;
  }
  .selection-box:hover {
    transform: scale(1);
    cursor: pointer;
    background-color: #96D3DD;
    color: #00B5C6;
    position: relative;
    height: fit-content;
    max-height: 400px;
    overflow-y: auto;
    z-index:20000;
  }
}

@media (max-width: 380px) {
  .img-container>img {
    margin-right: 15px;
    width: 60px !important;
    height: auto !important;
  }

  .selection-box {
    font-size: 20px;
  }
}

@media (pointer:coarse) {
  .icon-information {
    display: block;
  }

}

@media (hover: hover) and (min-width: 600px){
  .selection-box:hover {
    transform: scale(1.01);
    cursor: pointer;
    background-color: #96D3DD;
    color: #00B5C6;
    position: absolute;
    height: fit-content;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    max-height: 400px;
    overflow-y: auto;
    z-index:20000;
  }
  .selection-box::-webkit-scrollbar-thumb:hover {
    background: #03B5C6;
  }

  .selection-box:hover .description {
    display: block;
  }
  .selection-box:hover img {
    transform: scale(0.6);
  }
}

</style>
